import React, { type ReactElement } from 'react';

import classnames from 'classnames';

import { Animation } from '../Animation';
import { Paragraph } from '../Typography';

import animationDataSrc from './Loading.lottie.json';

import styles from './Loading.module.scss';

type LoadingProps = {
    text?: string;
    className?: string;
    size?: number;
};

const DEFAULT_SIZE = 32;

export const Loading = ({ text, className, size = DEFAULT_SIZE }: LoadingProps): ReactElement => {
    return (
        <div className={classnames(styles.container, className)}>
            <div className={styles.loading} aria-label="loading" aria-busy="true">
                <span className={styles.icon}>
                    <Animation
                        srcSync={animationDataSrc}
                        loop
                        autoplay
                        height={size}
                        width={size}
                    />
                </span>
                {!!text && <Paragraph className={styles.text}>{text}</Paragraph>}
            </div>
        </div>
    );
};
